module.exports = __webpack_public_path__ + "static/img/feather.023ba08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/package/theme/fonts/feather.svg
// module id = tdBw
// module chunks = 5